const engravingLimiter = function (string) {
  var re = new RegExp(
    "[^a-zA-Z0-9 '\u00E9\u00E0\u00E8\u00F9\u00E2\u00EA\u00EE\u00F4\u00FB\u00EB\u00EF\u00FC\u00E7]*",
    "g",
  );
  string = string.replace(re, "").substring(0, 12);
  return string;
};

function setupVariant(variant, field, activeValues) {
  const match = variant.options.some((item) => activeValues.includes(item));
  if (match) {
    field.style.display = "block";
    const input = field.querySelector("input,textarea");
    if (!input) return;
    input.removeAttribute("disabled");
  } else {
    field.style.display = "none";
    const input = field.querySelector("input,textarea");
    if (!input) return;
    input.value = "";
    input.setAttribute("disabled", "disabled");
  }
}

function setupToggleField(config) {
  const { field, activeValues, onInput } = config;

  if (!field) return;

  const variantPicker = field
    .closest(".product-form")
    ?.querySelector("variant-radios, variant-selects");

  const variantScript = variantPicker?.querySelector("script[data-selected-variant]");
  const initialVariant = variantScript ? JSON.parse(variantScript.textContent) : null;
  if (initialVariant) setupVariant(initialVariant, field, activeValues);

  if (onInput) field.addEventListener("input", onInput);

  subscribe(PUB_SUB_EVENTS.variantChange, function (data) {
    setupVariant(data.data.variant, field, activeValues);
  });
}

const productEngravingSelector = ".product-engraving-js";

const handleEngravingInput = (e) => {
  e.target.value = engravingLimiter(e.target.value);
};

const fieldConfigs = [
  {
    field: document.querySelector(productEngravingSelector),
    activeValues: [
      "Add Engraving",
      "Engraving",
      "Engraved Razor",
      "FREE Engraving",
      "FREE Engraving (Worth £6)",
    ],
    onInput: handleEngravingInput,
  },
];

fieldConfigs.forEach(setupToggleField);